<ng-container *ngIf="canAccessMeetingAI">

    <sfx-header disableDividers>
        <div class="section-header" data-layout="row" data-layout-align="space-between center">
            <span translate>Meeting tools</span>
            <button mat-button color="primary" track-id="connect-meeting-tool" [matMenuTriggerFor]="connectMeetingToolMenu">
                <span translate>Connect meeting tool</span>
            </button>
        </div>
    </sfx-header>

    <mat-menu #connectMeetingToolMenu="matMenu" class="connect-account-menu" xPosition="before">
        <button mat-menu-item track-id="connect-google-meet" (click)="connectGoogleMeet()">
            <mat-icon fontSet="salesflare" fontIcon="sf-icon-google-meet"></mat-icon>
            <span>{{ conferencingTypeConfig['google'].name }}</span>
        </button>
        <button mat-menu-item track-id="connect-microsoft-teams" (click)="connectMicrosoftTeams()">
            <mat-icon fontSet="salesflare" fontIcon="sf-icon-teams"></mat-icon>
            <span>{{ conferencingTypeConfig['office365'].name }}</span>
        </button>
        <button mat-menu-item track-id="connect-zoom" (click)="connectZoom()">
            <mat-icon fontSet="salesflare" fontIcon="sf-icon-zoom"></mat-icon>
            <span>{{ conferencingTypeConfig['zoom'].name }}</span>
        </button>
    </mat-menu>

    <sfx-section disableContentPadding>

        <p *ngIf="conferencingSourcesLoaded && conferencingSources.length === 0" class="section-empty-text" translate>No meeting tools connected yet!</p>

        <ng-container *ngFor="let source of conferencingSources">

            <mat-card appearance="outlined">
                <mat-card-header>
                    <img [src]="source.avatar" mat-card-avatar/>
                    <mat-card-title>{{ source.name }}</mat-card-title>
                    <mat-card-subtitle>{{ source.email }}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                    <button mat-button
                            track-id="disconnect-conferencing" (click)="disconnectConferencing(source)" [disabled]="source.disconnecting"
                            >
                        <span translate>Disconnect</span>
                    </button>
                </mat-card-actions>
            </mat-card>

        </ng-container>

    </sfx-section>

</ng-container>
